import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Card, CardBody, Col, Form, Row, Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import moment from "moment";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import ReportDateRangeSelect, { getReportDateRange } from "layouts/ReportDateRangeSelect";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { allShop, clearallShop } from "../../redux/handlers/manage/allShop.handler";
import { clearReportProductNotReadyDelivery, exportReportProductNotReadyDelivery, getReportProductNotReadyDeliveryDatalist, getReportProductNotReadyDeliveryWidget } from "../../redux/handlers/report/getReportProductNotReadyDelivery.handler";
import { getFullUrlPath } from "utils/HandleFileFunction";
var ProductBoxIcon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        viewBox: "0 0 64 64",
        width: "1em",
        height: "1em",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 20 32 7l25 13v28L32 61 7 48Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m7 20 25 13 25-13M32 33v28"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m19 14 25 13M25 11l13 7-7 4-13-7Z"
            })
        ]
    }));
};
var AffectedOrderIcon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        viewBox: "0 0 64 64",
        width: "1em",
        height: "1em",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5 8h8l5 32h31l8-25H15"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20 23h33M22 32h28M27 15l2 25M39 15l-1 25"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "24",
                cy: "51",
                r: "4"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "46",
                cy: "51",
                r: "4"
            })
        ]
    }));
};
var ProductQuantityIcon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        viewBox: "0 0 64 58",
        width: "1em",
        height: "1em",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true"
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs("g", {
                transform: "translate(20 1)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "m12 1 11 6v14l-11 6-11-6V7Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "m1 7 11 6 11-6M12 13v14"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("g", {
                transform: "translate(6 27)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "m12 1 11 6v14l-11 6-11-6V7Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "m1 7 11 6 11-6M12 13v14"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("g", {
                transform: "translate(34 27)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "m12 1 11 6v14l-11 6-11-6V7Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "m1 7 11 6 11-6M12 13v14"
                    })
                ]
            })
        ]
    }));
};
var AffectedShopIcon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        viewBox: "0 0 64 64",
        width: "1em",
        height: "1em",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 25v31h44V25M7 25h50l-6-16H13Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 25c0 5 4 8 8 8s8-3 8-8c0 5 4 8 9 8s9-3 9-8c0 5 4 8 8 8s8-3 8-8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M25 56V42h14v14"
            })
        ]
    }));
};
var numberText = function(value) {
    return Number(value || 0).toLocaleString("th-TH", {
        maximumFractionDigits: 0
    });
};
var getFirstValue = function(source, keys) {
    var fallback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var value = source === null || source === void 0 ? void 0 : source[key];
            if (value !== undefined && value !== null && value !== "") return value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return fallback;
};
var unwrapApiPayload = function(response) {
    var payload = response;
    for(var index = 0; index < 3; index += 1){
        if (!payload || Array.isArray(payload) || typeof payload !== "object") break;
        var isReportPayload = Array.isArray(payload.datalist) || Array.isArray(payload.rows) || Array.isArray(payload.items) || payload.totalPage !== undefined || payload.total_page !== undefined || payload.totalAmount !== undefined || payload.total_amount !== undefined || payload.widget !== undefined || payload.summary !== undefined;
        if (isReportPayload || payload.data === undefined) break;
        payload = payload.data;
    }
    return payload || {};
};
var getDatalistPayload = function(response) {
    var payload = unwrapApiPayload(response);
    var pagination = (payload === null || payload === void 0 ? void 0 : payload.pagination) || (payload === null || payload === void 0 ? void 0 : payload.meta) || {};
    var rows = Array.isArray(payload) ? payload : (payload === null || payload === void 0 ? void 0 : payload.datalist) || (payload === null || payload === void 0 ? void 0 : payload.rows) || (payload === null || payload === void 0 ? void 0 : payload.items) || (payload === null || payload === void 0 ? void 0 : payload.list) || (Array.isArray(payload === null || payload === void 0 ? void 0 : payload.data) ? payload.data : []);
    var totalAmount = Number(getFirstValue(payload, [
        "totalAmount",
        "total_amount",
        "total",
        "count"
    ], getFirstValue(pagination, [
        "totalAmount",
        "total_amount",
        "total"
    ], rows.length)));
    var totalPage = Number(getFirstValue(payload, [
        "totalPage",
        "total_page",
        "lastPage",
        "last_page"
    ], getFirstValue(pagination, [
        "totalPage",
        "total_page",
        "lastPage",
        "last_page"
    ], 1)));
    return {
        rows: Array.isArray(rows) ? rows : [],
        totalAmount: Number.isFinite(totalAmount) ? totalAmount : 0,
        totalPage: Number.isFinite(totalPage) && totalPage > 0 ? totalPage : 1
    };
};
var getWidgetPayload = function(response) {
    var payload = unwrapApiPayload(response);
    var widget = (payload === null || payload === void 0 ? void 0 : payload.widget) || (payload === null || payload === void 0 ? void 0 : payload.summary) || payload;
    if (!Array.isArray(widget)) return widget || {};
    return widget.reduce(function(result, item) {
        var key = getFirstValue(item, [
            "key",
            "name",
            "code",
            "type"
        ]);
        if (key) result[key] = getFirstValue(item, [
            "value",
            "total",
            "amount"
        ], 0);
        return result;
    }, {});
};
var getWidgetNumber = function(widget, keys) {
    var value = getFirstValue(widget, keys, 0);
    var number = Number(value || 0);
    return Number.isFinite(number) ? number : 0;
};
var getProductInfo = function(row) {
    return (row === null || row === void 0 ? void 0 : row.pdProduct) || (row === null || row === void 0 ? void 0 : row.PdProduct) || (row === null || row === void 0 ? void 0 : row.product) || (row === null || row === void 0 ? void 0 : row.product_info) || {};
};
var getProductName = function(row) {
    var product = getProductInfo(row);
    return getFirstValue(row, [
        "product_name",
        "product_nameth",
        "pd_product_nameth"
    ], getFirstValue(product, [
        "product_name",
        "product_nameth",
        "pd_product_nameth"
    ], "-"));
};
var getProductImage = function(row) {
    var product = getProductInfo(row);
    var image = getFirstValue(row, [
        "product_image",
        "product_image_url",
        "image",
        "image_url",
        "pd_product_image"
    ], getFirstValue(product, [
        "product_image",
        "product_image_url",
        "image",
        "image_url",
        "pd_product_image"
    ]));
    return image ? getFullUrlPath(String(image)) : "";
};
var getReportValues = function(value) {
    if (value === undefined || value === null || value === "") return [];
    if (Array.isArray(value)) return value;
    if (typeof value === "string") {
        var text = value.trim();
        if (text.startsWith("[") || text.startsWith("{")) {
            try {
                var parsed = JSON.parse(text);
                return Array.isArray(parsed) ? parsed : [
                    parsed
                ];
            } catch (_error) {
            // Use the original text when the API value is not JSON.
            }
        }
        if (/\r?\n|<br\s*\/?\s*>/i.test(text)) {
            return text.split(/\r?\n|<br\s*\/?\s*>/i).map(function(item) {
                return item.trim();
            }).filter(Boolean);
        }
    }
    return [
        value
    ];
};
var PackingSize = function(param) {
    var value = param.value;
    if (value && typeof value === "object") {
        var unitName = getFirstValue(value, [
            "unit_name"
        ], "-");
        var unitRatio = getFirstValue(value, [
            "unit_ratio"
        ], "-");
        return /*#__PURE__*/ _jsxs("div", {
            className: "not-ready-packing-size",
            children: [
                /*#__PURE__*/ _jsx("span", {
                    children: unitName
                }),
                /*#__PURE__*/ _jsx("span", {
                    children: "="
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "not-ready-packing-ratio",
                    children: numberText(unitRatio)
                }),
                /*#__PURE__*/ _jsx("span", {
                    children: "ชิ้น"
                })
            ]
        });
    }
    var text = String(value || "-").trim();
    var parts = text.match(/^(.*?)\s*=\s*([\d,.]+)\s*(.*)$/);
    if (!parts) return /*#__PURE__*/ _jsx("span", {
        children: text
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: "not-ready-packing-size",
        children: [
            /*#__PURE__*/ _jsx("span", {
                children: parts[1].trim()
            }),
            /*#__PURE__*/ _jsx("span", {
                children: "="
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "not-ready-packing-ratio",
                children: parts[2]
            }),
            /*#__PURE__*/ _jsx("span", {
                children: parts[3].trim()
            })
        ]
    });
};
var QuantityText = function(param) {
    var quantity = param.quantity, unitName = param.unitName;
    var text = String(quantity !== null && quantity !== void 0 ? quantity : "").trim();
    var alreadyHasUnit = /[^\d\s,.-]/.test(text);
    return /*#__PURE__*/ _jsx("span", {
        className: "fw-semibold",
        children: alreadyHasUnit ? text : "".concat(numberText(quantity), " ").concat(unitName || "ชิ้น")
    });
};
var SummaryCard = function(param) {
    var Icon = param.icon, title = param.title, value = param.value, unit = param.unit, color = param.color, background = param.background, loading = param.loading;
    return /*#__PURE__*/ _jsx("div", {
        className: "not-ready-summary-card h-100 p-3",
        style: {
            background: background,
            borderColor: "".concat(color, "24")
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "d-flex align-items-center gap-3 h-100",
            children: [
                /*#__PURE__*/ _jsx(Icon, {
                    className: "flex-shrink-0",
                    style: {
                        color: color,
                        fontSize: 48
                    }
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "fw-semibold mb-1",
                            children: title
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-28 fw-semibold text-dark lh-1 mb-2",
                            children: loading ? "-" : numberText(value)
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "fw-semibold",
                            style: {
                                color: color
                            },
                            children: unit
                        })
                    ]
                })
            ]
        })
    });
};
var UnitLines = function(param) {
    var units = param.units, render = param.render;
    return units.length ? /*#__PURE__*/ _jsx("div", {
        className: "w-100",
        children: units.map(function(unit, index) {
            return /*#__PURE__*/ _jsx("div", {
                className: "not-ready-unit-line".concat(index > 0 ? " mt-1" : ""),
                children: render(unit)
            }, "".concat(unit.id || unit.barcode || unit.unit_id || "unit", "-").concat(index));
        })
    }) : /*#__PURE__*/ _jsx("span", {});
};
export function ReportProductNotReadyDelivery() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var modalContextRef = useRef({
        modalObj: modalObj,
        setModalObj: setModalObj
    });
    var datalistReducer = useAppSelector(function(state) {
        return state.getReportProductNotReadyDeliveryDatalistReducer;
    });
    var widgetReducer = useAppSelector(function(state) {
        return state.getReportProductNotReadyDeliveryWidgetReducer;
    });
    var allShopReducer = useAppSelector(function(state) {
        return state.allShopReducer;
    });
    var _useState = _sliced_to_array(useState(null), 2), startDate = _useState[0], setStartDate = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), endDate = _useState1[0], setEndDate = _useState1[1];
    var _useState2 = _sliced_to_array(useState("custom"), 2), dateRange = _useState2[0], setDateRange = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), searchText = _useState3[0], setSearchText = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), debouncedSearchText = _useState4[0], setDebouncedSearchText = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), shopId = _useState5[0], setShopId = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), branchId = _useState6[0], setBranchId = _useState6[1];
    var _useState7 = _sliced_to_array(useState(1), 2), pageId = _useState7[0], setPageId = _useState7[1];
    var _useState8 = _sliced_to_array(useState(10), 2), pageSize = _useState8[0], setPageSize = _useState8[1];
    var _useState9 = _sliced_to_array(useState({}), 2), sortModel = _useState9[0], setSortModel = _useState9[1];
    var _useState10 = _sliced_to_array(useState(false), 2), isExporting = _useState10[0], setIsExporting = _useState10[1];
    useEffect(function() {
        modalContextRef.current = {
            modalObj: modalObj,
            setModalObj: setModalObj
        };
    }, [
        modalObj,
        setModalObj
    ]);
    useEffect(function() {
        var timer = window.setTimeout(function() {
            setDebouncedSearchText(searchText.trim());
            setPageId(1);
        }, 400);
        return function() {
            return window.clearTimeout(timer);
        };
    }, [
        searchText
    ]);
    var shops = useMemo(function() {
        var _allShopReducer_data;
        var data = (_allShopReducer_data = allShopReducer.data) === null || _allShopReducer_data === void 0 ? void 0 : _allShopReducer_data.data;
        return Array.isArray(data) ? data : [];
    }, [
        allShopReducer.data
    ]);
    var shopOptions = useMemo(function() {
        return shops.map(function(shop) {
            return {
                value: shop.sh_shop_id,
                label: shop.sh_shop_name || "ร้านค้า ".concat(shop.sh_shop_id)
            };
        });
    }, [
        shops
    ]);
    var branchOptions = useMemo(function() {
        var source = shopId ? shops.filter(function(shop) {
            return Number(shop.sh_shop_id) === Number(shopId);
        }) : shops;
        return source.flatMap(function(shop) {
            return (shop.shBranch || []).map(function(branch) {
                return {
                    value: branch.sh_branch_id,
                    label: shopId ? branch.sh_branch_name : "".concat(branch.sh_branch_name, " (").concat(shop.sh_shop_name, ")")
                };
            });
        });
    }, [
        shopId,
        shops
    ]);
    var filterPayload = useMemo(function() {
        return {
            sdate: startDate ? moment(startDate).format("YYYY-MM-DD") : "",
            edate: endDate ? moment(endDate).format("YYYY-MM-DD") : "",
            searchTxt: debouncedSearchText,
            shopid: shopId ? Number(shopId) : null,
            shbranchid: branchId ? Number(branchId) : null
        };
    }, [
        branchId,
        debouncedSearchText,
        endDate,
        shopId,
        startDate
    ]);
    useEffect(function() {
        dispatch(allShop(modalContextRef.current));
        return function() {
            dispatch(clearallShop());
            dispatch(clearReportProductNotReadyDelivery());
        };
    }, [
        dispatch
    ]);
    useEffect(function() {
        dispatch(getReportProductNotReadyDeliveryDatalist(_object_spread(_object_spread_props(_object_spread({}, filterPayload), {
            pageId: pageId,
            pageSize: pageSize
        }), sortModel.sortField && {
            sortField: sortModel.sortField,
            sortValue: sortModel.sortValue
        }), modalContextRef.current));
    }, [
        dispatch,
        filterPayload,
        pageId,
        pageSize,
        sortModel
    ]);
    useEffect(function() {
        dispatch(getReportProductNotReadyDeliveryWidget(filterPayload, modalContextRef.current));
    }, [
        dispatch,
        filterPayload
    ]);
    var datalist = useMemo(function() {
        return getDatalistPayload(datalistReducer.data);
    }, [
        datalistReducer.data
    ]);
    var widget = useMemo(function() {
        return getWidgetPayload(widgetReducer.data);
    }, [
        widgetReducer.data
    ]);
    var summary = useMemo(function() {
        return {
            total_not_ready_product: getWidgetNumber(widget, [
                "total_not_ready_product"
            ]),
            affected_order_count: getWidgetNumber(widget, [
                "affected_order_count"
            ]),
            total_not_ready_quantity_item: getWidgetNumber(widget, [
                "total_not_ready_quantity_item"
            ]),
            affected_shop_count: getWidgetNumber(widget, [
                "affected_shop_count"
            ])
        };
    }, [
        widget
    ]);
    useEffect(function() {
        if (!datalistReducer.isFetching && pageId > datalist.totalPage) {
            setPageId(datalist.totalPage);
        }
    }, [
        datalist.totalPage,
        datalistReducer.isFetching,
        pageId
    ]);
    var handleSort = function(column, sortDirection) {
        if (!(column === null || column === void 0 ? void 0 : column.sortField)) return;
        setSortModel({
            sortField: column.sortField,
            sortValue: sortDirection
        });
        setPageId(1);
    };
    var handleDateRangeChange = function(preset) {
        setDateRange(preset);
        var range = getReportDateRange(preset);
        if (range) {
            setStartDate(range.startDate);
            setEndDate(range.endDate);
            setPageId(1);
        }
    };
    var handleExport = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsExporting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            dispatch(exportReportProductNotReadyDelivery(_object_spread({}, filterPayload, sortModel.sortField && {
                                sortField: sortModel.sortField,
                                sortValue: sortModel.sortValue
                            }), modalContextRef.current))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsExporting(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleExport() {
            return _ref.apply(this, arguments);
        };
    }();
    var columns = useMemo(function() {
        return [
            {
                name: "#",
                center: true,
                width: "75px",
                cell: function(_row, index) {
                    return (pageId - 1) * pageSize + index + 1;
                }
            },
            {
                name: "รูปสินค้า",
                center: true,
                width: "130px",
                cell: function(row) {
                    var image = getProductImage(row);
                    return /*#__PURE__*/ _jsxs("div", {
                        className: "not-ready-product-image-wrapper",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: "ไม่มีรูป"
                            }),
                            image ? /*#__PURE__*/ _jsx("img", {
                                src: image,
                                alt: getProductName(row),
                                className: "not-ready-product-image",
                                onError: function(event) {
                                    event.currentTarget.style.display = "none";
                                }
                            }) : null
                        ]
                    });
                }
            },
            {
                name: "ชื่อสินค้า",
                sortField: "product_nameth",
                selector: function(row) {
                    return getProductName(row);
                },
                sortable: true,
                minWidth: "360px",
                wrap: true
            },
            {
                name: "บาร์โค้ด",
                sortField: "barcode",
                selector: function(row) {
                    return getFirstValue(getReportValues(row === null || row === void 0 ? void 0 : row.packing_size)[0], [
                        "barcode"
                    ], "");
                },
                sortable: true,
                center: true,
                minWidth: "220px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsx("div", {
                        className: "not-ready-barcode-cell w-100 text-center",
                        children: /*#__PURE__*/ _jsx(UnitLines, {
                            units: getReportValues(row === null || row === void 0 ? void 0 : row.packing_size),
                            render: function(packingSize) {
                                return packingSize.barcode && packingSize.barcode !== "-" ? packingSize.barcode : "";
                            }
                        })
                    });
                }
            },
            {
                name: "ขนาดบรรจุ",
                minWidth: "230px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsx(UnitLines, {
                        units: getReportValues(row === null || row === void 0 ? void 0 : row.packing_size),
                        render: function(packingSize) {
                            return /*#__PURE__*/ _jsx(PackingSize, {
                                value: packingSize
                            });
                        }
                    });
                }
            },
            {
                name: "จำนวนสินค้า",
                sortField: "quantity",
                selector: function(row) {
                    return getReportValues(row === null || row === void 0 ? void 0 : row.quantity).reduce(function(total, quantity) {
                        return total + Number(getFirstValue(quantity, [
                            "amount_item",
                            "amount"
                        ], 0) || 0);
                    }, 0);
                },
                sortable: true,
                minWidth: "180px",
                cell: function(row) {
                    return /*#__PURE__*/ _jsx(UnitLines, {
                        units: getReportValues(row === null || row === void 0 ? void 0 : row.quantity),
                        render: function(quantity) {
                            return /*#__PURE__*/ _jsx(QuantityText, {
                                quantity: getFirstValue(quantity, [
                                    "amount"
                                ], 0),
                                unitName: getFirstValue(quantity, [
                                    "unit_name"
                                ], "ชิ้น")
                            });
                        }
                    });
                }
            }
        ];
    }, [
        pageId,
        pageSize
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("style", {
                children: "\n        .not-ready-summary-card {\n          border: 1px solid;\n          border-radius: 12px;\n          min-height: 112px;\n        }\n\n        .not-ready-filter .react-datepicker-wrapper,\n        .not-ready-filter .react-datepicker__input-container {\n          width: 100%;\n        }\n\n        .not-ready-filter {\n          --not-ready-control-height: 46px;\n        }\n\n        .not-ready-filter .form-control,\n        .not-ready-filter .not-ready-select__control,\n        .not-ready-filter .btn-export-st-1 {\n          min-height: var(--not-ready-control-height);\n          height: var(--not-ready-control-height);\n        }\n\n        .not-ready-filter .btn-export-st-1 {\n          display: inline-flex;\n          align-items: center;\n          justify-content: center;\n        }\n\n        .not-ready-filter .not-ready-select__value-container,\n        .not-ready-filter .not-ready-select__indicators {\n          min-height: calc(var(--not-ready-control-height) - 2px);\n          height: calc(var(--not-ready-control-height) - 2px);\n        }\n\n        .not-ready-filter .not-ready-select__value-container {\n          padding-top: 0;\n          padding-bottom: 0;\n        }\n\n        .not-ready-filter .not-ready-select__input-container {\n          margin: 0;\n          padding-top: 0;\n          padding-bottom: 0;\n        }\n\n        .not-ready-unit-line {\n          display: flex;\n          align-items: center;\n          min-height: 28px;\n        }\n\n        .not-ready-barcode-cell .not-ready-unit-line {\n          justify-content: center;\n          text-align: center;\n        }\n\n        .not-ready-packing-size {\n          display: inline-flex;\n          align-items: center;\n          flex-wrap: wrap;\n          gap: 8px;\n          line-height: 28px;\n        }\n\n        .not-ready-packing-ratio {\n          display: inline-flex;\n          align-items: center;\n          justify-content: center;\n          min-width: 30px;\n          min-height: 28px;\n          padding: 0 7px;\n          border-radius: 4px;\n          background: #e8e9ec;\n          color: rgba(76, 78, 100, 0.87);\n        }\n\n        .not-ready-product-image-wrapper {\n          width: 58px;\n          height: 58px;\n          position: relative;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          overflow: hidden;\n          border-radius: 6px;\n          background: #f5f5f7;\n          color: #8a8d98;\n          font-size: 11px;\n        }\n\n        .not-ready-product-image {\n          position: absolute;\n          inset: 0;\n          width: 100%;\n          height: 100%;\n          object-fit: contain;\n          background: #fff;\n        }\n\n        @media (max-width: 575.98px) {\n          .not-ready-summary-card {\n            min-height: 100px;\n          }\n\n          .not-ready-summary-card .fs-28 {\n            font-size: 24px !important;\n          }\n        }\n      "
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "tc-7",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item active",
                                    children: "รายงานสินค้าไม่พร้อมจัดส่ง"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-3",
                        children: "รายงานสินค้าไม่พร้อมจัดส่ง"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Row, {
                className: "g-3 mb-3",
                children: [
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        sm: 6,
                        md: 4,
                        xl: 3,
                        children: /*#__PURE__*/ _jsx(SummaryCard, {
                            icon: ProductBoxIcon,
                            title: "รายการสินค้าไม่พร้อมจัดส่ง",
                            value: summary.total_not_ready_product,
                            unit: "รายการ",
                            color: "#b00612",
                            background: "#fff0f1",
                            loading: widgetReducer.isFetching
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        sm: 6,
                        md: 4,
                        xl: 3,
                        children: /*#__PURE__*/ _jsx(SummaryCard, {
                            icon: AffectedOrderIcon,
                            title: "จำนวนออเดอร์ที่ได้รับผลกระทบ",
                            value: summary.affected_order_count,
                            unit: "ออเดอร์",
                            color: "#f59e0b",
                            background: "#fff7ed",
                            loading: widgetReducer.isFetching
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        sm: 6,
                        md: 4,
                        xl: 3,
                        children: /*#__PURE__*/ _jsx(SummaryCard, {
                            icon: ProductQuantityIcon,
                            title: "จำนวนสินค้า (รวม)",
                            value: summary.total_not_ready_quantity_item,
                            unit: "ชิ้น",
                            color: "#1677ff",
                            background: "#eff6ff",
                            loading: widgetReducer.isFetching
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        sm: 6,
                        md: 4,
                        xl: 3,
                        children: /*#__PURE__*/ _jsx(SummaryCard, {
                            icon: AffectedShopIcon,
                            title: "ร้านค้าที่ได้รับผลกระทบ",
                            value: summary.affected_shop_count,
                            unit: "ร้านค้า",
                            color: "#ea580c",
                            background: "#fff5ed",
                            loading: widgetReducer.isFetching
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-2 mb-3",
                children: /*#__PURE__*/ _jsx(CardBody, {
                    children: /*#__PURE__*/ _jsxs(Row, {
                        className: "justify-content-start align-items-center gy-3 not-ready-filter",
                        children: [
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: 3,
                                lg: 2,
                                xl: 2,
                                children: /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-export-st-1",
                                    onClick: handleExport,
                                    disabled: isExporting,
                                    children: isExporting ? /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Spinner, {
                                                animation: "border",
                                                size: "sm",
                                                className: "me-2"
                                            }),
                                            "กำลังส่งออก"
                                        ]
                                    }) : "Export"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                sm: 12,
                                md: 3,
                                lg: 2,
                                xl: 2,
                                children: /*#__PURE__*/ _jsx(ReportDateRangeSelect, {
                                    value: dateRange,
                                    onChange: handleDateRangeChange,
                                    groupClassName: "form-st-3",
                                    classNamePrefix: "not-ready-select",
                                    controlHeight: 46
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                sm: 6,
                                md: 3,
                                lg: 4,
                                xl: 2,
                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                    className: "form-st-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Label, {
                                            className: "mb-1",
                                            children: "วันที่สั่งเริ่มต้น"
                                        }),
                                        /*#__PURE__*/ _jsx(DatePicker, {
                                            selected: startDate,
                                            onChange: function(date) {
                                                setDateRange("custom");
                                                setStartDate(date);
                                                setPageId(1);
                                            },
                                            dateFormat: "dd/MM/yyyy",
                                            className: "form-control",
                                            wrapperClassName: "w-100",
                                            placeholderText: "วัน/เดือน/ปี",
                                            maxDate: endDate,
                                            isClearable: true
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                sm: 6,
                                md: 3,
                                lg: 4,
                                xl: 2,
                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                    className: "form-st-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Label, {
                                            className: "mb-1",
                                            children: "ถึงวันที่"
                                        }),
                                        /*#__PURE__*/ _jsx(DatePicker, {
                                            selected: endDate,
                                            onChange: function(date) {
                                                setDateRange("custom");
                                                setEndDate(date);
                                                setPageId(1);
                                            },
                                            dateFormat: "dd/MM/yyyy",
                                            className: "form-control",
                                            wrapperClassName: "w-100",
                                            placeholderText: "วัน/เดือน/ปี",
                                            minDate: startDate,
                                            isClearable: true
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: 6,
                                lg: 6,
                                xl: 4,
                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                    className: "form-st-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Label, {
                                            className: "mb-1",
                                            children: "ค้นหาสินค้า"
                                        }),
                                        /*#__PURE__*/ _jsx(Form.Control, {
                                            type: "text",
                                            value: searchText,
                                            onChange: function(event) {
                                                return setSearchText(event.target.value);
                                            },
                                            placeholder: "ค้นหาชื่อสินค้า, บาร์โค้ด"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: 3,
                                lg: 3,
                                xl: 2,
                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                    className: "form-st-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Label, {
                                            className: "mb-1",
                                            children: "ค้นหาร้านค้า"
                                        }),
                                        /*#__PURE__*/ _jsx(Select, {
                                            className: "w-100 select-st-3",
                                            classNamePrefix: "not-ready-select",
                                            options: shopOptions,
                                            value: shopOptions.find(function(option) {
                                                return Number(option.value) === Number(shopId);
                                            }) || null,
                                            onChange: function(option) {
                                                setShopId((option === null || option === void 0 ? void 0 : option.value) || "");
                                                setBranchId("");
                                                setPageId(1);
                                            },
                                            placeholder: "ทั้งหมด",
                                            isClearable: true,
                                            isLoading: allShopReducer.isFetching
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: 3,
                                lg: 3,
                                xl: 2,
                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                    className: "form-st-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Label, {
                                            className: "mb-1",
                                            children: "ค้นหาสาขา"
                                        }),
                                        /*#__PURE__*/ _jsx(Select, {
                                            className: "w-100 select-st-3",
                                            classNamePrefix: "not-ready-select",
                                            options: branchOptions,
                                            value: branchOptions.find(function(option) {
                                                return Number(option.value) === Number(branchId);
                                            }) || null,
                                            onChange: function(option) {
                                                setBranchId((option === null || option === void 0 ? void 0 : option.value) || "");
                                                setPageId(1);
                                            },
                                            placeholder: "ทั้งหมด",
                                            isClearable: true,
                                            isLoading: allShopReducer.isFetching
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-2 mb-3",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "overflow-auto",
                    children: /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                        item: datalist.rows,
                        columns: columns,
                        isSelectRows: false,
                        currentPage: pageId,
                        currentPageSize: pageSize,
                        onChangePage: setPageId,
                        onChangePageSize: function(size) {
                            setPageSize(size);
                            setPageId(1);
                        },
                        totalPage: datalist.totalPage,
                        totalAmount: datalist.totalAmount,
                        sortModel: sortModel,
                        handleSort: handleSort,
                        loading: datalistReducer.isFetching
                    })
                })
            })
        ]
    });
}
